import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ClickAwayListener } from '@material-ui/core';

import './LobbyInformation.scss';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import useIsMobile from 'src/hooks/useIsMobile';
import Button from 'src/components/Button/Button';
import Icon from '../../Icon/Icon';

interface LobbyInformationProps{
  setShowInfo?: () => void,
  showInfo?: boolean
}

function LobbyInformation({ setShowInfo = () => {}, showInfo= false }: LobbyInformationProps) {
  const mobile = useIsMobile();
  const { t } = useTranslation();
  const { TRADING_MODE } = useContext(AppModeContext);
  const history = useHistory();

  if (!mobile){
    return (
      <>
        <div className="lobby-information__info">
          <div className="lobby-information__info-item">
            <div className="lobby-information__square lobby-information__open" />
            <span>{ t('horseDetail.open') }</span>
          </div>
          <div className="lobby-information__info-item">
            <div className="lobby-information__square lobby-information__started" />
            <span>{ t('horseDetail.running') }</span>
          </div>
          <div className="lobby-information__info-item">
            <div className="lobby-information__square lobby-information__resulted" />
            <span>{ t('horseDetail.resulted') }</span>
          </div>
          <div className="lobby-information__info-item">
            <div className="lobby-information__square lobby-information__cancelled" />
            <span>{ t('horseDetail.cancelled') }</span>
          </div>
          <div className="lobby-information__info-item">
            <div className="lobby-information__total-picks">{ t('horseDetail.t') }</div>
            <span>{ t('horseDetail.totePicks') }</span>
          </div>
          <div className="lobby-information__info-item">
            <div className="lobby-information__total-picks">{ t('horseDetail.fo') }</div>
            <span>{ t('horseDetail.fixedOdds') }</span>
          </div>
          <div className="lobby-information__info-item">
            <Icon icon="streaming" className="lobby-information__streamed" />
            <span>{ t('horseDetail.streamed') }</span>
          </div>

          {
            TRADING_MODE && (
              <div className="lobby-information__add-meeting">
                <Button className="btn--primary" text={ t('horseDetail.addMeeting') } onClick={ () => history.push('/add-meeting') } />
              </div>
            )
          }
        </div>
      </>
    );
  } else if (mobile && showInfo){
    return (
      <ClickAwayListener onClickAway={ setShowInfo }>
        <div className="lobby-information__info">
          <div className="lobby-information__status">
            <div className="lobby-information__info-item">
              <div className="lobby-information__square lobby-information__open" />
              <span>{ t('horseDetail.open') }</span>
            </div>
            <div className="lobby-information__info-item">
              <div className="lobby-information__square lobby-information__started" />
              <span>{ t('horseDetail.running') }</span>
            </div>
            <div className="lobby-information__info-item">
              <div className="lobby-information__square lobby-information__resulted" />
              <span>{ t('horseDetail.resulted') }</span>
            </div>
            <div className="lobby-information__info-item">
              <div className="lobby-information__square lobby-information__cancelled" />
              <span>{ t('horseDetail.cancelled') }</span>
            </div>
          </div>

          <div className="lobby-information__buttons">
            <div className="lobby-information__info-item">
              <div className="lobby-information__total-picks">{ t('horseDetail.fo') }</div>
              <span>{ t('horseDetail.fixedOdds') }</span>
            </div>
            <div className="lobby-information__info-item">
              <div className="lobby-information__total-picks">{ t('horseDetail.t') }</div>
              <span>{ t('horseDetail.totePicks') }</span>
            </div>
          </div>

          <div className="lobby-information__close">
            <div className="lobby-information__info-item">
              <Icon icon="streaming" className="lobby-information__streamed" />
              <span>{ t('horseDetail.streamed') }</span>
            </div>
          </div>
          <div className="lobby-information__info-item lobby-information__info-item--close">
            <Icon icon="close" className="horse-betting__closed" onClick={ setShowInfo } />
          </div>
        </div>
      </ClickAwayListener>
    );
  } else {
    return null;
  }
}

export default LobbyInformation;
